import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { System } from '../../shared-components/System';
import { HttpClient } from '@angular/common/http';
import { Card } from './card-container/card/card';
import { LoginService } from '../../shared-modules/login/login.service';
import { StudentNote } from '../../classroom360/student-notes/student-note.model';
import { StudentNoteCategory } from '../../classroom360/student-notes/student-note-category.model';
import { SharedService } from '../../shared-components/shared.service';
import { CheckInOutButtonSettings, CheckInOutSubmissionRequest } from './check-in-out-submission-request-modal/check-in-out-submission-request-modal.model';
import { AbsentNotice } from '../../admin360/attendance-administration/review-absent-notices/absent-notice.model';

@Injectable({
    providedIn: 'root'
})
export class StudentSummaryService {
    private _defaultCards: Card[] = [
        {
            title: 'Announcements',
            component: 'announcementCard',
            position: 0,
            columnPosition: 'L',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Detail',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: false
        },
        {
            title: 'Attendance',
            component: 'attendanceCard',
            position: 1,
            columnPosition: 'L',
            hasDetailCard: true,
            hasSummaryCard: true,
            display: 'Summary',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: false
        },
        {
            title: 'Assignments',
            component: 'assignmentsCard',
            position: 2,
            columnPosition: 'R',
            hasDetailCard: true,
            hasSummaryCard: true,
            display: 'Summary',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: false
        },
        {
            title: 'Current Grades',
            component: 'currentGradesCard',
            position: 3,
            columnPosition: 'L',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Detail',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: false
        },
        {
            title: 'District Defined Links',
            component: 'districtDefinedLinksCard',
            position: 4,
            columnPosition: 'L',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Detail',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: false
        },
        {
            title: 'Fees & Billing',
            component: 'feesAndBillingCard',
            position: 5,
            columnPosition: 'R',
            hasDetailCard: true,
            hasSummaryCard: true,
            display: 'Summary',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: false
        },
        {
            title: 'Meal Service Balance',
            component: 'mealServiceCard',
            position: 6,
            columnPosition: 'R',
            hasDetailCard: true,
            hasSummaryCard: true,
            display: 'Summary',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: false
        },
        {
            title: 'Student Schedule',
            component: 'studentScheduleCard',
            position: 7,
            columnPosition: 'R',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Detail',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: false
        },
        // {
        //     title: 'Upcoming Events',
        //     component: 'upcomingEventsCard',
        //     position: 8,
        //     columnPosition: 'R',
        //     hasDetailCard: true,
        //     hasSummaryCard: false,
        //     display: 'Detail',
        //     showInSettings: true,
        //     disabled: false,
        //     disabledMessage: '',
        //     staffOnly: false
        // },
        {
            title: 'Calendar',
            component: 'calendarCard',
            position: 9,
            columnPosition: 'L',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Detail',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: false
        },
        {
            title: 'Attendance History',
            component: 'attendanceHistoryCard',
            position: 10,
            columnPosition: 'R',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Detail',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: true
        },
        // {
        //     title: 'Student Teams',
        //     component: 'studentTeamsCard',
        //     position: 11,
        //     columnPosition: 'L',
        //     hasDetailCard: true,
        //     hasSummaryCard: false,
        //     display: 'Detail',
        //     showInSettings: true,
        //     disabled: false,
        //     disabledMessage: '',
        //     staffOnly: true
        // },
        {
            title: 'Student Notes',
            component: 'studentNotesCard',
            position: 12,
            columnPosition: 'R',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Detail',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: true
        },
        {
            title: 'Behavior',
            component: 'behaviorCard',
            position: 13,
            columnPosition: 'L',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Detail',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: true
        },
        {
            title: 'Programs and Services',
            component: 'programsAndServicesCard',
            position: 14,
            columnPosition: 'R',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Detail',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: true
        },
        {
            title: 'Student Details',
            component: 'studentDetailsCard',
            position: 15,
            columnPosition: 'L',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Detail',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: true
        },
        {
            title: 'Enrollment',
            component: 'enrollmentCard',
            position: 16,
            columnPosition: 'R',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Detail',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: true
        },
        {
            title: 'Contacts',
            component: 'contactsCard',
            position: 17,
            columnPosition: 'L',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Detail',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: true
        },
        {
            title: 'Student Schedule - Staff View',
            component: 'staffStudentScheduleCard',
            position: 18,
            columnPosition: 'R',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Detail',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: true
        },
        {
            title: 'Communications Log',
            component: 'communicationLogCard',
            position: 19,
            columnPosition: 'R',
            hasDetailCard: true,
            hasSummaryCard: false,
            display: 'Off',
            showInSettings: true,
            disabled: false,
            disabledMessage: '',
            staffOnly: true
        }
    ];
    hasSeenNewAnnouncementModal = false;
    acknowledgedStudentNotes: StudentNote[] = [];

    constructor(private http: HttpClient, private loginService: LoginService, private sharedService: SharedService) {
    }

    get defaultCards() {
        return this._defaultCards;
    }

    getStudentRecentEvents(studentId: number, memId: number, yearId: number, optionalInstanceIds: string = ''): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetStudentRecentEvents?studentId=${studentId}&memId=${memId}&yearId=${yearId}&optionalInstanceIds=${optionalInstanceIds}`, { observe: 'response' });
    }

    markEventsAsSeen(studentId: number, memId: number, eventType: string, yearId: number, optionalInstanceIds: string, studentDocumentIds: string = ''): Observable<any> {
        return this.http.get(System.apiURL.Student + `MarkEventsAsSeen?studentId=${studentId}&memId=${memId}&eventType=${eventType}&yearId=${yearId}&optionalInstanceIds=${optionalInstanceIds}&studentDocumentIds=${studentDocumentIds}`, { observe: 'response' });
    }

    getCardAnnouncements(studentId: number, loginId: number, schoolDomain: number, userType: number, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardAnnouncements?studentId=${studentId}&loginId=${loginId}&schoolDomain=${schoolDomain}&userType=${userType}&yearId=${yearId}`, { observe: 'response' });
    }

    getCardAssignments(studentId: number, schoolDomain: number, AYIdentifier: string, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardAssignments?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&yearId=${yearId}`, { observe: 'response' });
    }

    getCardMealService(studentId: number, schoolDomain: number, AYIdentifier: string, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardMealService?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&yearId=${yearId}`, { observe: 'response' });
    }

    getCardFeesAndBilling(studentId: number, schoolDomain: number, AYIdentifier: string, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardFeesAndBilling?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&yearId=${yearId}`, { observe: 'response' });
    }

    getCardAttendance(studentId: number, schoolDomain: number, AYIdentifier: string, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardAttendance?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&yearId=${yearId}`, { observe: 'response' });
    }

    getCardStudentSchedule(studentId: number, schoolDomain: number, AYIdentifier: string, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardStudentSchedule?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&yearId=${yearId}`, { observe: 'response' });
    }

    getCardStudentGrades(studentId: number, schoolDomain: number, AYIdentifier: string, gradingPeriodId: number, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardStudentGrades?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&gradingPeriodId=${gradingPeriodId}&yearId=${yearId}`, { observe: 'response' });
    }

    getCardUpcomingEvents(studentId: number, schoolDomain: number, AYIdentifier: string, userType: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardUpcomingEvents?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&userType=${userType}`, { observe: 'response' });
    }

    getCardStudentCalendar(studentId: number, schoolDomain: number, AYIdentifier: string, startDate: string, endDate: string, userType: number, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardStudentCalendar?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&userType=${userType}&startDate=${startDate}&endDate=${endDate}&yearId=${yearId}`, { observe: 'response' });
    }

    getCardStudentNotes(studentId: number, schoolDomain: number, AYIdentifier: string): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardStudentNotes?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}`, { observe: 'response' });
    }

    getCardStudentTeams(studentId: number, schoolDomain: number, AYIdentifier: string): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardStudentTeams?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}`, { observe: 'response' });
    }

    getCardStudentBehavior(studentId: number, schoolDomain: number, AYIdentifier: string, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardStudentBehavior?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&yearId=${yearId}`, { observe: 'response' });
    }

    getCardProgramsAndServices(studentId: number, schoolDomain: number, AYIdentifier: string, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardStudentProgramsAndServices?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&yearId=${yearId}`, { observe: 'response' });
    }

    getCardCourseRequestStatus(studentId: number, schoolDomain: number, AYIdentifier: string, parentMemId: number, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardCourseRequestStatus?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&parentMemId=${parentMemId}&yearId=${yearId}`, { observe: 'response' });
    }

    getCardOnlineRegistrationStatus(studentId: number, schoolDomain: number, AYIdentifier: string, parentMemId: number, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardOnlineRegistrationStatus?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&parentMemId=${parentMemId}&yearId=${yearId}`, { observe: 'response' });
    }

    getOnlineRegistrationStatus(yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetOnlineRegistrationStatus?yearId=${yearId}`, { observe: 'response' });
    }

    getCourseRequestStatus(studentId: number, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCourseRequestStatus?studentId=${studentId}&yearId=${yearId}`, { observe: 'response' });
    }

    getGradingPeriodDetails(schoolDomain: number, AYIdentifier: string): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetGradingPeriodDetails?schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}`, { observe: 'response' });
    }

    getStudentsNewAnnouncements(studentId: number, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetStudentsNewAnnouncements?studentId=${studentId}&yearId=${yearId}`);
    }

    getEventForDateRange(studentId: number, schoolDomain: number, AYIdentifier: string, fromDate: string, toDate: string, userType: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetEventForDateRange?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&userType=${userType}&fromDate=${fromDate}&toDate=${toDate}`, { observe: 'response' });
    }

    getStudentNotesForPopup(studentId: number, schoolId: number, yearId: number): Observable<StudentNote[]> {
        return this.http.get<StudentNote[]>(System.apiURL.Student + `GetStudentNotesForPopup?studentId=${studentId}&schoolId=${schoolId}&yearId=${yearId}`);
    }

    getStudentNoteCategories(schoolId: number, yearId: number): Observable<StudentNoteCategory[]> {
        return this.sharedService.getStudentNoteCategories(schoolId, yearId);
    }

    getCardStudentEnrollment(studentId: number, schoolDomain: number, AYIdentifier: string): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardStudentEnrollment?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}`, { observe: 'response' });
    }

    getCardStudentContacts(studentId: number, schoolDomain: number, AYIdentifier: string, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardStudentContacts?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&yearId=${yearId}`, { observe: 'response' });
    }

    getCardStudentAttendance(studentId: number, schoolDomain: number, AYIdentifier: string, yearId: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetCardStudentAttendance?studentId=${studentId}&schoolDomain=${schoolDomain}&AYIdentifier=${AYIdentifier}&yearId=${yearId}`, { observe: 'response' });
    }

    getAttendanceHistoryDetail(studentId: number, sectionId: number, type: string): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetAttendanceHistoryDetail?studentId=${studentId}&sectionId=${sectionId}&type=${type}`, { observe: 'response' });
    }

    getMembershipCodes(RSNY_ID: number): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetMembershipCodes?RSNY_ID=${RSNY_ID}`, { observe: 'response' });
    }

    getCheckInOutButtonSettings(studentId: number, yearId: number): Observable<CheckInOutButtonSettings> {
        return this.http.get<CheckInOutButtonSettings>(System.apiURL.Student + `GetCheckInOutButtonSettings?studentId=${studentId}&yearId=${yearId}`);
    }

    getCheckInOutSubmissionRequest(studentId: number): Observable<CheckInOutSubmissionRequest> {
        return this.http.get<CheckInOutSubmissionRequest>(System.apiURL.Student + `GetCheckInOutSubmissionRequest?studentId=${studentId}`);
    }

    saveCheckInOutSubmissionRequest(requestData: CheckInOutSubmissionRequest, yearId: number): Observable<boolean> {
        return this.http.post<boolean>(System.apiURL.Student + `SaveCheckInOutSubmissionRequest?yearId=${yearId}`, requestData);
    }

    getAbsentNoticeByStudentId(studentId: number): Observable<AbsentNotice> {
        return this.http.get<AbsentNotice>(System.apiURL.Admin + `GetAbsentNoticeByStudentId?studentId=${studentId}`);
    }

}
